//nếu chưa đăng nhập ko cho vào router update custemer,
// ds đơn hàng, chi tiết đơn hàng,...
//về nhà làm
import React from "react";
import { useSelector } from "react-redux";
import { Navigate } from "react-router-dom";

const CheckNotLogged = (OriginComponent) => {
  const login = useSelector(({ auth }) => auth.login);
  //chuyen huong khi chưa login về trang chủ
  return login.logged ? <OriginComponent /> : <Navigate to="/" />;
};

export default CheckNotLogged;
